export default __webpack_public_path__ + "static/media/vector-art-1.6738f0da.png";